
import { ReactSVG } from 'react-svg'
import visibilityIcon from '../../assets/icons/visibility.svg'
import visibilityOffIcon from '../../assets/icons/visibility_off.svg'
import { colors } from 'shared-ui'
import { css } from '@emotion/react'

export default function VisibilityToggle({ isVisible, setIsVisible, title, ...props }) {

    return <div title={title}>
        {isVisible ?
            <ReactSVG
                src={visibilityIcon}
                css={style}
                onClick={() => setIsVisible(false)}
                {...props}
            />
            :
            <ReactSVG
                src={visibilityOffIcon}
                onClick={() => setIsVisible(true)}
                css={style}
                {...props}
            />}
    </div>
}

const style = css`
    width: 2.5em;
    height: 2.5em;
    color: ${colors.soft};
    border-radius: 5px;
    padding: 0.25em;
    cursor: pointer;
    
    &:hover {
        color: ${colors.white};
        background: ${colors.eventLight};
    }
`